
const goodListLangCN = {
    synthesize: "综合",
    salesQuantity: "销量",
    price:"价格",
    filter: "筛选",
    research:"请输入搜索关键词",
    reset:"重置",
    confirm:"确定",
    brands:"品牌",

}


const goodListLangEN = {
    synthesize: "Synthesize",
    salesQuantity: "Sales quantity",
    price:"Price",
    filter: "Filter",
    research:"Please Enter your research key words",
    reset:"Reset",
    confirm:"Confirm",
    brands:"Brands"
}

const langPackage = {
    cn:goodListLangCN,
    en:goodListLangEN
}

export {langPackage}

